import React, { useState } from "react";
import { baseurl } from "../baseurl";
import axios from "axios";
import Swal from "sweetalert2"; // Import SweetAlert2
import "../assets/css/seller.css";

function BecomeSeller() {
  const [formData, setFormData] = useState({
    name: "", email: "", phone: "", password_hash: "",
    business_name: "", gst_number: "", address_line1: "",
    city: "", state: "", country: "India", postal_code: "",
  });

  // State for terms checkbox
  const [agreed, setAgreed] = useState(false);

  // Configuration for Swal Toast
  const Toast = Swal.mixin({
    toast: true,
    position: "top-end",
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.onmouseenter = Swal.stopTimer;
      toast.onmouseleave = Swal.resumeTimer;
    }
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Check if terms are agreed
    if (!agreed) {
      Toast.fire({
        icon: "warning",
        title: "Terms Required",
        text: "Please agree to the terms and conditions to proceed.",
        background: "#212529",
        color: "#fff",
      });
      return;
    }
    
    console.log("Submitting Seller Registration Data:", formData);

    try {
      const response = await axios.post(`${baseurl}vendorRegisterUser`, formData);
      
      console.log("Server Response:", response.data);

      // Show Success Toast
      await Toast.fire({
        icon: "success",
        title: "Application Sent Successfully!",
        text: "Redirecting to vendor portal...",
        background: "#212529",
        color: "#fff",
        iconColor: "#b0954b",
        timer: 2000, // Show for 2 seconds
        showConfirmButton: false
      });

      // Redirect to the vendor portal
      window.location.href = "https://vendor.subcity.in/";

    } catch (error) {
      console.error("Submission Error:", error);

      Toast.fire({
        icon: "error",
        title: "Registration Failed",
        text: error.response?.data?.message || "Please try again later.",
        background: "#212529",
        color: "#fff",
        iconColor: "#f54c4d"
      });
    }
  };

  return (
    <div className="seller-main-container">
      {/* Dark Hero Section */}
      <section className="seller-hero-section">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6 mb-5 mb-lg-0 text-center text-lg-start">
              <span className="seller-badge">Seller Central</span>
              <h1 className="hero-heading mt-3">
                Unlock Millions of <br />
                <span className="text-gold">SubCity</span> Buyers
              </h1>
              <p className="hero-text">
                The most transparent marketplace for professional sellers. 
                List your products with 0% setup fee and dedicated support.
              </p>
            </div>
            <div className="col-lg-6">
              {/* Floating Registration Form */}
              <div className="registration-card shadow">
                <div className="card-top-accent"></div>
                <div className="p-4 p-md-5">
                  <h3 className="form-title">Start Selling</h3>
                  <p className="form-subtitle">Create your business account today</p>
                  
                  <form onSubmit={handleSubmit} className="custom-form mt-4">
                    <div className="section-divider"><span>Personal Info</span></div>
                    <div className="row g-3 mb-4">
                      <div className="col-md-6">
                        <input type="text" name="name" className="form-input" placeholder="Full Name" onChange={handleChange} required />
                      </div>
                      <div className="col-md-6">
                        <input type="email" name="email" className="form-input" placeholder="Email Address" onChange={handleChange} required />
                      </div>
                      <div className="col-md-6">
                        <input type="tel" name="phone" className="form-input" placeholder="Phone Number" onChange={handleChange} required />
                      </div>
                      <div className="col-md-6">
                        <input type="password" name="password_hash" className="form-input" placeholder="Set Password" onChange={handleChange} required />
                      </div>
                    </div>

                    <div className="section-divider"><span>Business Details</span></div>
                    <div className="row g-3">
                      <div className="col-12">
                        <input type="text" name="business_name" className="form-input" placeholder="Business / Store Name" onChange={handleChange} required />
                      </div>
                      <div className="col-md-7">
                        <input type="text" name="gst_number" className="form-input" placeholder="GST Number (Optional)" onChange={handleChange} />
                      </div>
                      <div className="col-md-5">
                        <input type="text" name="postal_code" className="form-input" placeholder="Pincode" onChange={handleChange} required />
                      </div>
                      <div className="col-12">
                        <input type="text" name="address_line1" className="form-input" placeholder="Address" onChange={handleChange} required />
                      </div>
                      <div className="col-md-6">
                        <input type="text" name="city" className="form-input" placeholder="City" onChange={handleChange} required />
                      </div>
                      <div className="col-md-6">
                        <input type="text" name="state" className="form-input" placeholder="State" onChange={handleChange} required />
                      </div>
                    </div>




                    <div className="text-dark bths">

                     <h4>E-COMMERCE SELLER REGISTRATION AGREEMENT</h4> 
<h5>Subcity International Marketing Pvt Ltd</h5>


<p>
This Seller Agreement (“Agreement”) is made and entered into on this _ day of ____, 20, by and between:
</p>
<p>Subcity International Marketing Pvt Ltd, a company incorporated under the Companies Act, having its registered office at __________ (hereinafter referred to as the “Company” or “Platform”)</p>

<p>AND</p>

<p>Seller Name: __________</p>
<p>Business Name: __________</p>
<p>Address: __________</p>
<p>GST Number: __________</p>
<p>PAN Number: __________</p>
<p>(Hereinafter referred to as the “Seller”)</p>

---

<p>1. PURPOSE</p>

<p>The Company operates an e-commerce platform under the brand Subcity, enabling sellers to list and sell products to customers. The Seller agrees to register and sell products through the platform under the terms stated herein.</p>

---

<p>2. SELLER REGISTRATION</p>

<p>- Seller must provide accurate business details, KYC documents, and bank information.</p>
<p>- The Company reserves the right to approve or reject any seller registration without prior notice.</p>

---

<p>3. PRODUCT LISTING</p>

<p>- Seller shall list only genuine, legal, and approved products.</p>
<p>- Products must comply with all applicable laws including FSSAI, AYUSH, GST, etc.</p>
<p>- Seller is responsible for product quality, description, pricing, and inventory.</p>

 

<p>4. PRICING & COMMISSION</p>

<p>- Seller agrees to pay a commission of _% per sale to the Company.</p>
<p>- The Company may revise commission rates with prior notice.</p>
<p>- All pricing must be inclusive/exclusive of GST as per applicable law.</p>

---

<p>5. ORDER MANAGEMENT</p>

<p>- Seller must accept and process orders within _ hours.</p>
<p>- Seller is responsible for packaging and dispatching products on time.</p>
<p>- Delay may lead to penalties or suspension.</p>

---

<p>6. PAYMENT TERMS</p>

<p>- Payments will be settled to the Seller within _ days after successful delivery.</p>
<p>- Payments will be transferred to the registered bank account.</p>
<p>- The Company may deduct commission, penalties, and other charges.</p>

---

<p>7. RETURNS & REFUNDS</p>

<p>- Seller agrees to accept returns as per Company return policy.</p>
<p>- Refunds will be processed after product verification.</p>
<p>- Seller bears responsibility for defective or damaged products.</p>

---

<p>8. SELLER OBLIGATIONS</p>

<p>Seller agrees:</p>

<p>- Not to sell prohibited or illegal products</p>
<p>- To maintain proper stock levels</p>
<p>- To provide accurate product information</p>
<p>- To comply with all legal and tax regulations</p>

---

<p>9. COMPANY RIGHTS</p>

<p>The Company reserves the right to:</p>

<p>- Remove product listings</p>
<p>- Suspend or terminate seller account</p>
<p>- Modify platform policies</p>

---

<p>10. INTELLECTUAL PROPERTY</p>

<p>Seller shall not use Company brand name, logo, or content without permission.</p>

---

<p>11. TERMINATION</p>

<p>- Either party may terminate this Agreement with 7 days notice.</p>
<p>- Company may terminate immediately in case of fraud, misconduct, or policy violation.</p>

---

<p>12. LIABILITY</p>

<p>The Company shall not be liable for:</p>

<p>- Product defects</p>
<p>- Seller disputes</p>
<p>- Delivery delays caused by Seller</p>

---

<p>13. GOVERNING LAW</p>

<p>This Agreement shall be governed by the laws of India. Any disputes shall be subject to jurisdiction of ____ Court.</p>

---

<p> 14. ACCEPTANCE</p>

<p> By registering on the platform, the Seller agrees to all terms and conditions mentioned above.</p>

---

<p>For Subcity International Marketing Pvt Ltd</p>
 
 


                    </div>

                    <div className="mt-4 d-flex align-items-start">
                      <input 
                        type="checkbox" 
                        id="terms" 
                        className="form-check-input me-2 mt-1" 
                        checked={agreed} 
                        onChange={(e) => setAgreed(e.target.checked)}
                      />
                      <label htmlFor="terms" className="text-dark small" style={{ cursor: 'pointer' }}>
                        I confirm that I have read and agree to the SubCity Terms and Conditions and Privacy Policy.
                      </label>
                    </div>

                    <button type="submit" className="btn-seller-primary mt-4">
                      Complete Registration
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Trust & Features Section */}
      <section className="features-section py-5">
        <div className="container">
          <div className="row text-center g-4">
            <div className="col-md-4">
              <div className="feature-box">
                <i className="bi bi-lightning-fill text-gold fs-1"></i>
                <h5 className="mt-3 fw-bold">Fast Onboarding</h5>
                <p className="text-muted small">Go live in as little as 24 hours with our automated KYC process.</p>
              </div>
            </div>
            <div className="col-md-4">
              <div className="feature-box">
                <i className="bi bi-wallet2 text-gold fs-1"></i>
                <h5 className="mt-3 fw-bold">Secure Payouts</h5>
                <p className="text-muted small">Direct bank settlements every Tuesday with detailed invoicing.</p>
              </div>
            </div>
            <div className="col-md-4">
              <div className="feature-box">
                <i className="bi bi-graph-up text-gold fs-1"></i>
                <h5 className="mt-3 fw-bold">Seller Analytics</h5>
                <p className="text-muted small">Real-time data to help you understand your customers' needs.</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default BecomeSeller;